import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import NewControl from '../components/NewControl';
import {
  NEW_CONTROL_TYPE_BY_CONTAINER_TYPE,
  REPORT_CONTROL_TYPE,
} from '../constants/report-designer.constants';
import DynamicControl from '../DynamicControl';
import { getHasValidationErrorById } from '../selectors/report-designer.selectors';

const useStyles = makeStyles({
  reportDataContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '6px 4px',
  },
  container: {
    display: 'block',
  },
  main: {
    minHeight: 30,
  },
  error: {
    border: 'solid 2px red !important',
    borderRadius: 5,
    '&:hover': {
      border: 'solid 2px red !important',
    },
  },
});

const SSReportContainer = ({ id, controlType, childrenNodes }) => {
  const classes = useStyles();

  const hasValidationError = useSelector((state) => getHasValidationErrorById(state, { id }));

  const newControlType = NEW_CONTROL_TYPE_BY_CONTAINER_TYPE[controlType] || {};

  return (
    <div
      className={classNames({
        [classes.main]: !childrenNodes.length,
        [classes.reportDataContainer]: controlType === REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER,
        [classes.container]: controlType !== REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER,
        [classes.error]: hasValidationError,
      })}
    >
      {childrenNodes.map((id) => (
        <DynamicControl key={id} id={id} />
      ))}
      <NewControl
        parentId={id}
        controlType={newControlType}
        emptyControl={newControlType === REPORT_CONTROL_TYPE.CROSS_TAB}
      />
    </div>
  );
};

export default SSReportContainer;
